<template>
  <div>
    <h3>Olá {{this.$store.state.usuario.usuario.NomeCompleto}}</h3>
    <p>Enviamos uma mensagem com um link para você acessar o sistema (nesse email a gente define uma senha e no link já deixa ele acessar).</p>
  </div>
</template>

<script>
export default {
  name: 'LoginCpf',
  data: function () {
    return {
    }
  },
  created () {

  },
  destroyed () {
    this.limparFinalizarCompraMenu()
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/LoginCpf.vue